module.exports = __webpack_public_path__ + "static/gallery-store-833194af2bf6e103360faf63b09d7e25.svg";